// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { UserHistoryProvider } from './context/UserHistoryContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <AuthProvider>
      <UserHistoryProvider>
        <App />
      </UserHistoryProvider>
    </AuthProvider>
  // </React.StrictMode>
);
